import { render, staticRenderFns } from "./PageEducatorInstitutionTeacherInvite.vue?vue&type=template&id=53ebba9a&scoped=true&"
import script from "./PageEducatorInstitutionTeacherInvite.vue?vue&type=script&lang=js&"
export * from "./PageEducatorInstitutionTeacherInvite.vue?vue&type=script&lang=js&"
import style0 from "./PageEducatorInstitutionTeacherInvite.vue?vue&type=style&index=0&id=53ebba9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ebba9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VContainer})
